module.exports = "pegasus/assets/circleline-youtube.png";